import React from 'react';
import './App.css';
import NavigationBar from "./NavigationBar";
import Button from "react-bootstrap/Button";
import {Company} from "./Company";

interface AppProps {
    company?: Company
}

function App(props: AppProps) {
    const [buttonMsg,buttonRedirect] = props.company ?
        ["Logout", "/logout"] :
        ["Login with Square", "/login"];

    return (
    <div>
      <NavigationBar loggedIn={props.company !== undefined}/>
        <div className="bg-dark py-5">
            <div className="container px-5">
                <div className="row gx-5 align-items-center justify-content-center">
                    <div className="my-5 text-center text-xl-start">
                        <h1 className="display-5 fw-bolder text-white mb-2">GenPost</h1>
                        <p className="lead fw-normal text-white-50 mb-4">Create the presence of your brand on socials hassle-free</p>
                            <a className="logo" href={buttonRedirect}>
                                <Button>{buttonMsg}</Button>
                            </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="bg-light py-5">
            <div className="container px-5">
                <div className="row gx-5 align-items-center justify-content-center">
                    <div className="my-5 text-center text-xl-start">
                        <h3 className="display-5 text-dark fw-bolder mb-2">How it works</h3>
                        <ol>
                            <li>Register with your Square account</li>
                            <li>Describe your company and brand style</li>
                            <li>Generate post using items directly from Square</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default App;
